{
  "$id": "wealthlane://forms/vesting-template",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../vesting-template.domain.json",
  "properties": {
    "id": {
      "$ref": "module://vesting-template#properties/id"
    },
    "name": {
      "$ref": "module://vesting-template#properties/name",
      "required": true
    },
    "summary": {
      "$ref": "module://vesting-template#properties/summary"
    },
    "vestingTypeId": {
      "$ref": "module://vesting-template#properties/vestingTypeId",
      "required": true,
      "actionId": "FETCH_VESTING_TYPE_OPTIONS",
      "dependsOn": []
    },
    "vestingType": {
      "$ref": "module://vesting-template#properties/vestingType"
    },
    "vestingTypeLabel": {
      "$ref": "module://vesting-template#properties/vestingTypeLabel"
    },
    "isCliffVesting": {
      "$ref": "module://vesting-template#properties/isCliffVesting"
    },
    "isStepVesting": {
      "$ref": "module://vesting-template#properties/isStepVesting"
    },
    "isHybridVesting": {
      "$ref": "module://vesting-template#properties/isHybridVesting"
    },
    "loadingTypeId": {
      "$ref": "module://vesting-template#properties/loadingTypeId",
      "actionId": "FETCH_VESTING_LOADING_TYPE_OPTIONS",
      "dependsOn": [],
      "hiddenWhen": { "field": "vestingTypeLabel", "equals": "Custom Vesting Tranche" },
      "disabledWhen": { "field": "vestingTypeLabel", "equals": "Specific Vesting" },
      "clearOnHideWhen": true
    },
    "endOfTheMonthTypeId": {
      "$ref": "module://vesting-template#properties/endOfTheMonthTypeId",
      "actionId": "FETCH_END_OF_MONTH_TYPE_OPTIONS",
      "dependsOn": [],
      "hiddenWhen": {
        "anyOf": [
          { "field": "vestingTypeLabel", "equals": "Specific Vesting" },
          { "field": "vestingTypeLabel", "equals": "Custom Vesting Tranche" }
        ]
      },
      "clearOnHideWhen": true
    },
    "specificVestingInstruction": {
      "$ref": "module://vesting-template#properties/specificVestingInstruction",
      "requiredWhen": { "field": "vestingTypeLabel", "equals": "Specific Vesting" },
      "hiddenWhen": { "field": "vestingTypeLabel", "notEquals": "Specific Vesting" },
      "clearOnHideWhen": true
    },
    "periodStartDate": {
      "$ref": "module://vesting-template#properties/periodStartDate",
      "requiredWhen": {
        "allOf": [
          { "field": "vestingTypeId", "notEmpty": true },
          { "field": "isCliffVesting", "notEquals": true },
          { "field": "isStepVesting", "notEquals": true },
          { "field": "isHybridVesting", "notEquals": true },
          { "field": "vestingTypeLabel", "notEquals": "Specific Vesting" },
          { "field": "vestingTypeLabel", "notEquals": "Custom Vesting Tranche" }
        ]
      },
      "hiddenWhen": {
        "anyOf": [
          { "field": "vestingTypeId", "isEmpty": true },
          { "field": "vestingTypeLabel", "equals": "Specific Vesting" },
          { "field": "vestingTypeLabel", "equals": "Custom Vesting Tranche" },
          { "field": "isCliffVesting", "equals": true },
          { "field": "isStepVesting", "equals": true },
          { "field": "isHybridVesting", "equals": true }
        ]
      },
      "clearOnHideWhen": true
    },
    "lengthInMonths": {
      "$ref": "module://vesting-template#properties/lengthInMonths",
      "requiredWhen": {
        "allOf": [
          { "field": "vestingTypeId", "notEmpty": true },
          { "field": "vestingTypeLabel", "notEquals": "Specific Vesting" },
          { "field": "vestingTypeLabel", "notEquals": "Custom Vesting Tranche" }
        ]
      },
      "hiddenWhen": {
        "anyOf": [
          { "field": "vestingTypeId", "isEmpty": true },
          { "field": "vestingTypeLabel", "equals": "Specific Vesting" },
          { "field": "vestingTypeLabel", "equals": "Custom Vesting Tranche" }
        ]
      },
      "clearOnHideWhen": false
    },
    "cliffPeriodHelperNote": {
      "$ref": "module://vesting-template#properties/cliffPeriodHelperNote",
      "readOnly": true,
      "hiddenWhen": { "field": "isCliffVesting", "notEquals": true },
      "adapterProps": {
        "hideLabel": true,
        "variant": "body-s"
      }
    },
    "vestsAfterInMonths": {
      "$ref": "module://vesting-template#properties/vestsAfterInMonths",
      "requiredWhen": { "field": "isHybridVesting", "equals": true },
      "hiddenWhen": {
        "anyOf": [
          { "field": "vestingTypeId", "isEmpty": true },
          { "field": "vestingTypeLabel", "equals": "Specific Vesting" },
          { "field": "vestingTypeLabel", "equals": "Custom Vesting Tranche" },
          { "field": "isHybridVesting", "notEquals": true }
        ]
      },
      "disabledWhen": { "field": "lengthInMonths", "isEmpty": true },
      "clearOnHideWhen": false
    },
    "amountOneInPercentage": {
      "$ref": "module://vesting-template#properties/amountOneInPercentage",
      "hiddenWhen": {
        "anyOf": [
          { "field": "vestingTypeId", "isEmpty": true },
          { "field": "isCliffVesting", "equals": true },
          { "field": "isStepVesting", "equals": true },
          { "field": "vestingTypeLabel", "equals": "Specific Vesting" },
          { "field": "vestingTypeLabel", "equals": "Custom Vesting Tranche" },
          {
            "allOf": [
              { "field": "isHybridVesting", "notEquals": true },
              { "field": "vestingTypeLabel", "notEquals": "Custom Vesting" }
            ]
          }
        ]
      },
      "clearOnHideWhen": false
    },
    "intervalInMonths": {
      "$ref": "module://vesting-template#properties/intervalInMonths",
      "requiredWhen": {
        "anyOf": [
          { "field": "isStepVesting", "equals": true },
          { "field": "isHybridVesting", "equals": true },
          { "field": "vestingTypeLabel", "equals": "Custom Vesting" }
        ]
      },
      "disabledWhen": {
        "anyOf": [
          { "field": "lengthInMonths", "isEmpty": true },
          {
            "allOf": [
              { "field": "isHybridVesting", "equals": true },
              { "field": "vestsAfterInMonths", "isEmpty": true }
            ]
          }
        ]
      },
      "actionId": "FETCH_VESTING_FREQUENCY_OPTIONS",
      "dependsOn": ["lengthInMonths", "vestsAfterInMonths"],
      "resetOnParamsChange": true,
      "paramMap": {
        "lengthInMonths": "lengthInMonths",
        "vestsAfterInMonths": "vestsAfterInMonths"
      },
      "adapterHintWhen": {
        "condition": { "field": "isStepVesting", "equals": true },
        "trueHint": "number",
        "falseHint": "async-select"
      },
      "hiddenWhen": {
        "anyOf": [
          { "field": "vestingTypeId", "isEmpty": true },
          { "field": "vestingTypeLabel", "equals": "Specific Vesting" },
          { "field": "vestingTypeLabel", "equals": "Custom Vesting Tranche" },
          { "field": "isCliffVesting", "equals": true },
          {
            "allOf": [
              { "field": "isStepVesting", "notEquals": true },
              { "field": "isHybridVesting", "notEquals": true },
              { "field": "vestingTypeLabel", "notEquals": "Custom Vesting" }
            ]
          }
        ]
      },
      "clearOnHideWhen": false
    },
    "roundingTypeId": {
      "$ref": "module://vesting-template#properties/roundingTypeId",
      "requiredWhen": {
        "allOf": [
          { "field": "vestingTypeId", "notEmpty": true },
          { "field": "isCliffVesting", "notEquals": true },
          { "field": "vestingTypeLabel", "notEquals": "Custom Vesting Tranche" }
        ]
      },
      "actionId": "FETCH_ROUNDING_TYPE_OPTIONS",
      "dependsOn": [],
      "hiddenWhen": {
        "anyOf": [
          { "field": "vestingTypeId", "isEmpty": true },
          { "field": "isCliffVesting", "equals": true },
          { "field": "vestingTypeLabel", "equals": "Custom Vesting Tranche" }
        ]
      },
      "clearOnHideWhen": false
    },
    "vestAtEndOfMonth": {
      "$ref": "module://vesting-template#properties/vestAtEndOfMonth"
    },
    "vestsInMonths": {
      "$ref": "module://vesting-template#properties/vestsInMonths"
    },
    "fractionalDecimalDigit": {
      "$ref": "module://vesting-template#properties/fractionalDecimalDigit"
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_VESTING_TEMPLATE",
      "refreshEntities": ["VestingTemplate"],
      "invalidateQueries": ["getVestingTemplateList", "getGrantVestingTemplateList"]
    }
  },
  "modes": {
    "create": {
      "dataSource": {
        "submit": {
          "successMessage": "Vesting template added."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_VESTING_TEMPLATE_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "successMessage": "Vesting template edited."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_VESTING_TEMPLATE_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
